<template>
  <div class="new-application">
    <el-card class="box-card">
      <el-upload
        :on-change="handlePreview"
        :action="fileUrl"
        :headers="uploadHeaders"
        :show-file-list="false"
        :auto-upload="true"
        :multiple="false"
        :accept="'.txt,.docx'"
        :data="{ifAcrossTheGroup: 1}"
        ref="upload"
        style="margin:14px;">
        <el-button size="small" type="primary">导入模板</el-button>
      </el-upload>
      <folded-panel infoName="申请单明细">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="isEdit"
            :showSaveBtn="isEdit"
            :disabled="!isEdit"
            @save="save(1)"
            @submit="submit(2)"
            @cancelForm="cancel"
            @input="handelInput"
          />
        </div>
      </folded-panel>
      <!-- <drag-dialog :show="dialogShow" :title="'审批人选择'" :width="'50%'" @close="close">
        <dynamic-form
            labelWidth="110px"
            :formConfig="dialogForm"
            v-model="form"
            :showBtn="true"
            :showSaveBtn="false"
            :disabled="false"
          />
      </drag-dialog> -->
     <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import { addForm,idQuery,updatedForm } from "@/api/bill/applicationForm";
import { getDocumentCode } from "@/views/utils";
import initDict from "@/mixin/initDict";
import { parseTime } from "@/utils";
import FoldedPanel from "@/components/FoldedPanel"
import DragDialog from "@/components/DragDialog"
import { getToken } from "@/utils/auth";
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
export default {
  name: "AddForm",
  mixins: [initDict],
  components: { FoldedPanel,DragDialog,PersonStep },
  data() {
    return {
      loading: false,
      id: "",
      dialogShow: false,
      importArr: [],
      form: { frameType: [], supportContent: []},
      isEdit: false,
      dialogForm: {
        formItemList: [
          {
            label: "审批人1",
            key: "proposer",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "审批人2",
            key: "proposers",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
        ]
      },
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "input",
            key: "name",
            label: "申请单名称",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "databox",
            key: "bsProject",
            label: "项目名称",
            placeholder: "请选择项目",
            value: "",
            span: 8,
            props: {
            label: "name",
            value: "id"
            },
            url: "/bizTaskDecomposition/findProject",
            tableColumn: [
            {
                property: "code",
                label: "项目号",
                query: {
                type: "input"
                }
            },
            {
                property: "name",
                label: "项目名称",
                query: {
                type: "input"
                }
            }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
         },
         {
            type: "input",
            key: "projectCode",
            label: "项目编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "申请人",
            key: "proposer",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "所属事业部",
            key: "department",
            type: "input",
            placeholder: "请选择项目",
            span: 8,
            disabled: true,
          },
          {
            label: "项目经理",
            key: "projectManager",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
               {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "项目经理电话",
            key: "projectManagerPhone",
            span: 8,
            type: "input",
            disabled: true,
          },
          {
            label: "技术对接人",
            key: "skillBacker",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
               {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "select",
            key: "skillBackerPhone",
            label: "对接人联系电话",
            span: 8,
            options: [],
            disabled: true
          },
          {
            type: "date",
            key: "predictStartTime",
            label: "预计开始时间",
            value: "",
            span: 8,
            valueFormat: "yyyy-MM-dd",
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "date",
            key: "lastCompletionTime",
            label: "要求完成时间",
            value: "",
            span: 8,
            valueFormat: "yyyy-MM-dd",
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "number",
            key: "predictManDay",
            label: "预计投入人天",
            disabled: false,
            value: "",
            placeholder: "请输入",
            span: 8,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "checkbox",
            key: "frameType",
            label: "框架类型",
            disabled: false,
            value: [],
            span: 20,
            border: false,
            hidden: false,
            options: []
          },
          {
            type: "checkbox",
            key: "supportContent",
            label: "支持内容",
            disabled: false,
            value: [],
            span: 20,
            border: false,
            options: []
          },
          {
            type: "textarea",
            key: "supportContentExplain",
            label: "支持内容简要说明",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 20,
             maxlength: 200,
          },
          {
              span: 10,
              type: "radio",
              label: "支持类型",
              value: "0",
              button: false,
              border: false,
              key: "ifAcrossTheGroup",
              options: [
                  {
                      value: "1",
                      label: "跨事业部支持",
                  },
                  {
                      value: "0",
                      label: "非跨事业部支持",
                  },
                  {
                      value: "2",
                      label: "框架技术支持",
                  }
              ],
          },
        ]
      },
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      receipTypes: [],
      fileUrl: `${process.env.VUE_APP_BASE_API}/attachment/uploadDile`,
      uploadHeaders: {},
      personStepData: [],
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
    };
  },
  created() {
    this.uploadHeaders = { Authorization: `Bearer ${getToken()}` }
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      idQuery(this.id).then(res => {
        if (!res.data.frameTypeList) {
          res.data.frameTypeList = []
        }
        if (!res.data.supportContentList) {
          res.data.supportContentList = []
        }
        this.form = res.data
        this.form.frameType = res.data.frameTypeList
        this.form.supportContent = res.data.supportContentList
        this.form.proposer = res.data.proposerPerson
        this.form.projectManager = {name: res.data.projectManagerName,id: res.data.projectManager}
        this.form.skillBacker = {name: res.data.skillBackerName,id: res.data.skillBacker}
        this.form.frameType.length > 0 ? this.handelInput(this.form,"ifAcrossTheGroup") : ''
        this.form.supportContent.length > 0 ? this.handelInput(this.form,"frameType") : ''
        this.handelInput(this.form,"supportContent")
      })
    } else {
      this.form.code = getDocumentCode("JSZC");
    }
    this.getDict("frameType").then(res => { // 框架类型
      this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'frameType')].options = res.data;
    });
    this.getDict("supportContent").then(res => { // 支持内容
      this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'supportContent')].options = res.data;
    });
  },
  watch: {
  },
  methods: {
    /**
     * 表单值改变
     */
    handelInput(val,key) {
      // 框架类型
      const remarkdIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "frameType")
      const reIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "frameTypeElse")
      const conObj = {
        type: "input",
        key: "frameTypeElse",
        label: "其他框架类型",
        value: "",
        span: 16,
        hidden: false,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      }
      // 支持内容
      const cenIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "supportContent")
      const contendIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "supportContentElse")
      const cenObj = {
        type: "input",
        key: "supportContentElse",
        label: "其他支持内容",
        value: "",
        span: 16,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      }
      const index = this.formConfig.formItemList.findIndex(ele => ele.key === "ifAcrossTheGroup")
      const obj = {
        type: "number",
        key: "predictMoney",
        label: "预计结算金额",
        value: "",
        span: 8,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      }
      switch (key) {
        case "ifAcrossTheGroup": // 是否跨事业部
          if (val[key] === "1") {
            this.formConfig.formItemList.splice(index + 1,0,obj)
          } else {
            const moneyIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "predictMoney")
            if (moneyIndex !== -1) {
              this.form.predictMoney = ''
              this.formConfig.formItemList.splice(moneyIndex,1)
            }
          }
          if (val[key] === "2") {
            this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === "frameType")].hidden = true
            reIndex !== -1 ? this.formConfig.formItemList[reIndex].hidden = true : ''
          } else {
            this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === "frameType")].hidden = false
            reIndex !== -1 ? this.formConfig.formItemList[reIndex].hidden = false : ''
          }
          break;
        case "frameType": // 框架类型
          if (val[key].includes("1") && reIndex === -1) {
            this.formConfig.formItemList.splice(remarkdIndex + 1,0,conObj)
          } else if (!val[key].includes("1") && reIndex !== -1) {
            this.form.frameTypeElse = ''
            this.formConfig.formItemList.splice(reIndex,1)
          }
          break;
        case "supportContent": // 支持内容
          if (val[key].includes("1") && contendIndex === -1) {
            this.formConfig.formItemList.splice(cenIndex + 1,0,cenObj)
          } else if (!val[key].includes("1") && contendIndex !== -1) {
            this.form.supportContentElse = ""
            this.formConfig.formItemList.splice(contendIndex,1)
          }
          break;
        case "bsProject":
          if (val[key]) {
            this.form.projectCode = val[key].code
            this.form.name = val[key].name + "/" + parseTime(new Date(),'{y}-{m}-{d}') + "/" + "申请单"
          } else {
            this.form.projectCode = ""
            this.form.name = ""
          }
          break;
        case "proposer": // 申请人
          if (val[key]) {
            this.form.department = val[key].departmentName
          } else {
            this.form.department = ""
          }
          break;
        case "projectManager": // 项目经理
          if (val[key]) {
            this.form.projectManagerPhone = val[key].telephone
          } else {
            this.form.projectManagerPhone = ""
          }
          break;
        case "skillBacker": // 技术对接人
          if (val[key]) {
            this.form.skillBackerPhone = val[key].telephone
          } else {
            this.form.skillBackerPhone = ""
          }
          break;
        case "lastCompletionTime": // 要求完成时间
          if (val[key] && val["predictStartTime"]) {
            new Date(val[key]).getTime() >= new Date(val["predictStartTime"]).getTime() ? '' : (this.$notify({
              title: "完成时间必须大于开始时间",
              type: "warning",
              duration: 2500
            }),
            this.form.lastCompletionTime = '')
          }
          break;
        case "predictStartTime": // 预计开始时间
          if (val[key] && val["lastCompletionTime"]) {
            new Date(val[key]).getTime() <= new Date(val["lastCompletionTime"]).getTime() ? '' : (this.$notify({
              title: "开始时间必须小于完成时间",
              type: "warning",
              duration: 2500
            }), this.form.predictStartTime = '')
          }
          break;
        default:
          break;
      }
    },
    handlePreview(files) {
      // fileUpload({ file: files }).then(res => {
      //   debugger
      // })
    },
    close() {
        this.stepShow = false;
    },
    submitConfirm(val) {
      // this.getFormData(2,val)
      this.loading = true
       const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      obj.from = "applicationForm"
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
    // 提交
    submit(status) {
      // this.pull(this.getFormData(status));
          this.loading = true
          getFlowNode({ from: "applicationForm", id: this.form.id }).then(res => {
          this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
          }
        });
    },
    // 保存
    save(status) {
      this.loading = true
      this.pull(this.getFormData(status));
    },
    // 组装表单数据
    getFormData(status, val) {
      const obj = {...this.form}
      obj.billState = status;
      obj.frameTypeList = obj.frameType
      obj.frameType = ''
      obj.supportContentList = obj.supportContent
      obj.supportContent = ''
      obj.projectCode = obj.bsProject.code
      obj.projectManager = obj.projectManager.id
      obj.proposer = obj.proposer.id
      obj.skillBacker = obj.skillBacker.id
      return obj
    },
    cancel() {
      this.$router.go(-1);
    },
    back() {
      this.$router.go(-1);
    },
    pull(obj) {
      if (this.id) {
        updatedForm(obj).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      } else {
        addForm(obj).then(res => {
           this.loading = false
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-icon-back {
  padding-bottom: 10px;
}
</style>
